import axios from 'axios';
import { JsonConvert, OperationMode, ValueCheckingMode } from "json2typescript";
import { IdentityServerDAO } from './IdentityServerDAO';
import { UserAuthenticationRequest } from "@/API/Models/Authentication/UserAuthenticationRequest";
import { UserAuthenticationResponse } from "@/API/Models/Authentication/UserAuthenticationResponse";
import { GetUserInformationResponse } from "@/API/Models/Authentication/GetUserInformationResponse";
import { GetUserInformationRequest } from "@/API/Models/Authentication/GetUserInformationRequest";
import { BaseResponse } from "@/API/Models/BaseResponse";
import { ResendConfirmation } from "@/API/Models/Account/ResendConfirmation";
import { ConfirmAccount } from "@/API/Models/Account/ConfirmAccount";
import { ResetPassword } from "@/API/Models/Account/ResetPassword";
export class AuthenticationDAO {
    static async authenticateUser(emailAddress, password, requestParameters) {
        console.log('Email: ' + emailAddress);
        let token = await IdentityServerDAO.getServiceProviderAccessToken();
        let axiosConfig = {
            headers: {
                Authorization: token,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*"
            }
        };
        let authRequest = new UserAuthenticationRequest();
        authRequest.emailAddress = emailAddress;
        authRequest.password = password;
        authRequest.requestParameters = requestParameters;
        let response = await axios.post(process.env.VUE_APP_API_BASE_URL + '/user/authenticate', authRequest, axiosConfig);
        let jsonConvert = new JsonConvert();
        jsonConvert.operationMode = OperationMode.LOGGING;
        jsonConvert.ignorePrimitiveChecks = false;
        jsonConvert.valueCheckingMode = ValueCheckingMode.DISALLOW_NULL;
        let authResponse = jsonConvert.deserializeObject(response.data, UserAuthenticationResponse);
        return authResponse;
    }
    static async getUserInformation(emailAddress) {
        let token = await IdentityServerDAO.getServiceProviderAccessToken();
        return this.getUserInformationWithToken(emailAddress, token);
    }
    static async getUserInformationWithToken(emailAddress, token) {
        let axiosConfig = {
            headers: {
                Authorization: token,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*"
            }
        };
        let infoRequest = new GetUserInformationRequest();
        infoRequest.emailAddress = emailAddress;
        console.log('Sending: ' + JSON.stringify(infoRequest));
        let response = await axios.post(process.env.VUE_APP_API_BASE_URL + '/profile/emailExists', infoRequest, axiosConfig);
        let jsonConvert = new JsonConvert();
        jsonConvert.operationMode = OperationMode.LOGGING;
        jsonConvert.ignorePrimitiveChecks = false;
        jsonConvert.valueCheckingMode = ValueCheckingMode.DISALLOW_NULL;
        let userResponse = jsonConvert.deserializeObject(response.data, GetUserInformationResponse);
        console.log("returning: " + userResponse);
        return userResponse;
    }
    static async confirmAccount(confirmationCode, emailAddress) {
        let jsonConvert = new JsonConvert();
        jsonConvert.operationMode = OperationMode.LOGGING;
        jsonConvert.ignorePrimitiveChecks = false;
        jsonConvert.valueCheckingMode = ValueCheckingMode.DISALLOW_NULL;
        let token = await IdentityServerDAO.getServiceProviderAccessToken();
        let axiosRegisterConfig = {
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Accept': 'application/json'
            }
        };
        let confirmEmail = new ConfirmAccount();
        confirmEmail.confirmationCode = confirmationCode;
        confirmEmail.emailAddress = emailAddress;
        let response = await axios.post(process.env.VUE_APP_API_BASE_URL + '/profile/confirm', JSON.stringify(jsonConvert.serializeObject(confirmEmail)), axiosRegisterConfig);
        let confirmResponse = jsonConvert.deserializeObject(response.data, BaseResponse);
        return confirmResponse;
    }
    static async resendAccountConfirmation(emailAddress) {
        let jsonConvert = new JsonConvert();
        jsonConvert.operationMode = OperationMode.LOGGING;
        jsonConvert.ignorePrimitiveChecks = false;
        jsonConvert.valueCheckingMode = ValueCheckingMode.DISALLOW_NULL;
        let token = await IdentityServerDAO.getServiceProviderAccessToken();
        let axiosRegisterConfig = {
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Accept': 'application/json'
            }
        };
        let resendConfirmation = new ResendConfirmation();
        resendConfirmation.emailAddress = emailAddress;
        let response = await axios.post(process.env.VUE_APP_API_BASE_URL + '/profile/resend-confirmation', JSON.stringify(jsonConvert.serializeObject(resendConfirmation)), axiosRegisterConfig);
        let confirmResponse = jsonConvert.deserializeObject(response.data, BaseResponse);
        return confirmResponse;
    }
    static async recoverPassword(emailAddress) {
        let jsonConvert = new JsonConvert();
        jsonConvert.operationMode = OperationMode.LOGGING;
        jsonConvert.ignorePrimitiveChecks = false;
        jsonConvert.valueCheckingMode = ValueCheckingMode.DISALLOW_NULL;
        let token = await IdentityServerDAO.getServiceProviderAccessToken();
        let axiosRegisterConfig = {
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Accept': 'application/json'
            }
        };
        let resendConfirmation = new ResendConfirmation();
        resendConfirmation.emailAddress = emailAddress;
        let response = await axios.post(process.env.VUE_APP_API_BASE_URL + '/user/recovery', JSON.stringify(jsonConvert.serializeObject(resendConfirmation)), axiosRegisterConfig);
        let confirmResponse = jsonConvert.deserializeObject(response.data, BaseResponse);
        return confirmResponse;
    }
    static async resetPassword(confirmationCode, password) {
        let jsonConvert = new JsonConvert();
        jsonConvert.operationMode = OperationMode.LOGGING;
        jsonConvert.ignorePrimitiveChecks = false;
        jsonConvert.valueCheckingMode = ValueCheckingMode.DISALLOW_NULL;
        let token = await IdentityServerDAO.getServiceProviderAccessToken();
        let axiosRegisterConfig = {
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Accept': 'application/json'
            }
        };
        let resetPassword = new ResetPassword();
        resetPassword.confirmationCode = confirmationCode;
        resetPassword.password = password;
        let response = await axios.post(process.env.VUE_APP_API_BASE_URL + '/user/reset-password', JSON.stringify(jsonConvert.serializeObject(resetPassword)), axiosRegisterConfig);
        let confirmResponse = jsonConvert.deserializeObject(response.data, BaseResponse);
        return confirmResponse;
    }
}
